import React, { useEffect, useState } from "react";
import { Users, Plus, Trash2, Pencil, Check, X } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminStaff() {
  const [staff, setStaff] = useState([]);
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [editId, setEditId] = useState(null);
  const [editF, setEditF] = useState({ name: "", password: "" });

  const load = () => api.get("/admin/staff").then(({ data }) => setStaff(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!f.name || !f.email || f.password.length < 6) { toast.error("Fill all fields (password min 6)"); return; }
    try {
      await api.post("/admin/staff", f);
      toast.success("Staff account created");
      setF({ name: "", email: "", password: "" });
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  const startEdit = (u) => { setEditId(u.id); setEditF({ name: u.name, password: "" }); };
  const saveEdit = async (id) => {
    const body = {};
    if (editF.name) body.name = editF.name;
    if (editF.password) body.password = editF.password;
    try {
      await api.put(`/admin/staff/${id}`, body);
      toast.success("Staff updated");
      setEditId(null);
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  const remove = async (id) => { try { await api.delete(`/admin/staff/${id}`); toast.success("Removed"); load(); } catch { toast.error("Failed to remove"); } };

  return (
    <div data-testid="admin-staff">
      <h1 className="font-heading font-extrabold text-2xl mb-1 flex items-center gap-2"><Users size={22} /> Staff Accounts</h1>
      <p className="text-sm text-muted-foreground mb-5">Kitchen/staff logins for your branch. They only see the live orders screen.</p>

      <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6 grid md:grid-cols-4 gap-3 items-end">
        <input data-testid="staff-name" placeholder="Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="rounded-xl border border-gray-200 px-4 py-2.5 text-sm" />
        <input data-testid="staff-email" placeholder="Login email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="rounded-xl border border-gray-200 px-4 py-2.5 text-sm" />
        <input data-testid="staff-password" type="password" placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="rounded-xl border border-gray-200 px-4 py-2.5 text-sm" />
        <button data-testid="staff-create" onClick={create} className="bg-metros-red text-white rounded-full px-4 py-2.5 text-sm font-bold flex items-center justify-center gap-1"><Plus size={16} /> Add Staff</button>
      </div>

      <div className="grid gap-2">
        {staff.map((u) => (
          <div key={u.id} data-testid={`staff-row-${u.id}`} className="bg-white border border-gray-100 rounded-xl p-3">
            {editId === u.id ? (
              <div className="grid md:grid-cols-3 gap-2 items-center">
                <input data-testid={`staff-edit-name-${u.id}`} value={editF.name} onChange={(e) => setEditF({ ...editF, name: e.target.value })} placeholder="Name" className="rounded-lg border border-gray-200 px-3 py-2 text-sm" />
                <input data-testid={`staff-edit-password-${u.id}`} type="password" value={editF.password} onChange={(e) => setEditF({ ...editF, password: e.target.value })} placeholder="New password (optional)" className="rounded-lg border border-gray-200 px-3 py-2 text-sm" />
                <div className="flex gap-2">
                  <button data-testid={`staff-save-${u.id}`} onClick={() => saveEdit(u.id)} className="flex-1 bg-metros-red text-white rounded-full px-3 py-2 text-sm font-bold flex items-center justify-center gap-1"><Check size={15} /> Save</button>
                  <button data-testid={`staff-cancel-${u.id}`} onClick={() => setEditId(null)} className="rounded-full px-3 py-2 text-sm font-semibold border border-gray-200 flex items-center gap-1"><X size={15} /></button>
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-between">
                <div><p className="font-semibold text-sm">{u.name}</p><p className="text-xs text-muted-foreground">{u.email}</p></div>
                <div className="flex items-center gap-1">
                  <button data-testid={`staff-edit-${u.id}`} onClick={() => startEdit(u)} className="text-gray-400 hover:text-metros-black p-1"><Pencil size={16} /></button>
                  <button data-testid={`staff-del-${u.id}`} onClick={() => remove(u.id)} className="text-gray-400 hover:text-metros-red p-1"><Trash2 size={16} /></button>
                </div>
              </div>
            )}
          </div>
        ))}
        {staff.length === 0 && <p className="text-sm text-muted-foreground text-center py-6">No staff accounts yet.</p>}
      </div>
    </div>
  );
}
